<template>
  <div class="page-search-page">
    <!-- 搜索栏 -->
    <div class="top-bar">
      <div class="search-input-box">
        <img
          class="search-icon"
          src="https://select-oil-oss.vchangyi.com/wxapp/icon-search.png"
        />
        <input
          placeholder="请输入车辆品牌或VIN码"
          @confirm="search"
          id="search-input"
          type="text"
          confirm-type="search"
          v-model="input_value"
          ref="searchInput"
        />
        <div class="clear-icon" v-if="input_value" @click="clearInputValue">
          <img
            src="https://select-oil-oss.vchangyi.com/wxapp/icon-circle-close.png"
          />
        </div>
      </div>
      <div
        class="handle-button"
        v-if="input_focus && !input_value"
        @click="cancel"
      >
        搜索
      </div>
      <div class="handle-button" v-else @click="search">搜索</div>
    </div>
    <!-- 品牌列表 -->
    <div class="brand-list" v-if="brand_list.length > 0">
      <div
        class="item"
        hover-class="item--hover"
        @click="showCarSelectPopup(1, item)"
        v-for="item in brand_list"
        :key="item.id"
      >
        <img :src="item.logo_url" />
        <div class="brand-name">{{ item.name }}</div>
      </div>
    </div>
    <div class="empty-page" v-else>
      <img
        src="https://select-oil-oss.vchangyi.com/wxapp/search-empty-bg.png"
      />
      <div class="tip">暂无车辆信息</div>
    </div>
    <!-- 搜索vin码、上传vin码展示的车型列表 -->
    <popup-select
      :accessMenus="accessMenus"
      :defaultList="defaultList"
      :v-model="vehiclePopup"
      :initParams="initParams"
      @close="closeVehiclePopup"
    />
    <!-- （点击品牌）厂家-车系弹出层 -->
    <series-popup
      :is_new_energy="current_is_new_energy"
      :initParams="initParams"
      :visible="seriesVisible"
      @close="seriesVisible = false"
    ></series-popup>
  </div>
</template>
<script>
import api from "@/apis/maintenance-api.js";
import validToken from "@/mixins/valid-token.js";
import PopupSelect from "@/components/PopupSelect.vue";
import SeriesPopup from "@/components/SeriesPopup.vue";
export default {
  name: "SearchPage",
  components: {
    PopupSelect,
    SeriesPopup,
  },
  mixins: [validToken],
  data() {
    return {
      brand_list: [],
      input_value: "",
      seriesVisible: false,
      vehiclePopup: false,
      initParams: {},
      accessMenus: [],
      vinCarList: [],
      defaultList: {},
      input_focus: false,
      current_is_new_energy: 2,
    };
  },
  mounted() {
    this.accessMenus = JSON.parse(sessionStorage.getItem("valid_menus"));
    this.$refs.searchInput.focus();
  },
  methods: {
    showCarSelectPopup(index, current) {
      const { name, logo_url, is_new_energy } = current;
      if (index == 1) {
        this.current_is_new_energy = is_new_energy;
        this.initParams = { brand_name: name, logo: logo_url, is_new_energy };
        this.seriesVisible = true;
        return;
      }
    },
    /**
     * 点击搜索vin码或品牌名称
     */
    async search() {
      if (!this.input_value) {
        return;
      }
      let reg = new RegExp(/[a-z0-9A-Z]{17}/);
      if (reg.test(this.input_value)) {
        await this.fetchValidToken(this.fetchVinModelList);
      } else {
        this.$loading.show("加载中...");
        api.searchData({ name: this.input_value }).then((res) => {
          if (res.code == 0) {
            this.brand_list = res.data;
            if (this.brand_list.length == 0) {
              this.$toast.show({
                showTime: 2,
                message: "暂无车辆信息",
                style: "error",
              });
            }
          } else {
            this.$toast.show({
              showTime: 2,
              message: res.message,
              style: "error",
            });
          }
          this.$loading.hide();
        });
      }
    },
    /**
     * vin码车型列表
     */
    fetchVinModelList() {
      this.$loading.show("加载中...");
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      api
        .getModelDetail({
          vehicle_vin: this.input_value,
          parts_type: 1,
          token: this.token,
          scheme_id,
        })
        .then((res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.vinCarList = res.data.vehicle_list;
            this.vinCarList.forEach(
              (i) =>
                (i.text = `${i.brand_name} ${i.model_alias} ${
                  i.release_year
                }款${i.sales_name} ${i.model_name || ""} ${
                  i.engine_model ? i.engine_model : ""
                }`)
            );
            this.defaultList.internal_from = "text_vin";
            this.defaultList.list = this.vinCarList;
            this.defaultList.singleTitle = {
              title: "请选择车型",
              pic: res.data.vehicle_list[0].brand_logo_url,
            };
            this.vehiclePopup = true;
          } else {
            this.$toast.show({
              showTime: 2,
              message: res.message,
              style: "error",
            });
          }
        });
    },
    /**
     * 关闭车型弹出层
     */
    closeVehiclePopup() {
      this.vehiclePopup = false;
      this.defaultList = {
        internal_from: "", //内部来源 标识vin码字符串搜索（text_vin）还是vin码图片识别（photo_vin），用于埋点区分来源
        singleTitle: {
          title: "",
        },
        list: [],
      };
    },
    /**
     * 清空输入值及品牌列表
     */
    clearInputValue() {
      this.input_value = "";
      this.brand_list = [];
    },
  },
};
</script>
<style scoped lang="less">
.empty-page {
  transform: translateY(26vh);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666666;
  line-height: 34/100rem;
  font-size: 24/100rem;
  img {
    width: 133/100rem;
    height: 133/100rem;
    margin-bottom: 34/100rem;
  }
}
.page-search-page {
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  // 搜索栏
  .top-bar {
    position: sticky;
    top: 0;
    padding: 34/100rem 0 16/100rem 0;
    margin: 0 27/100rem;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8/100rem;
    .search-input-box {
      background: #fafafa;
      // width: 100%;
      flex: 1;
      height: 75/100rem;
      border-radius: 20/100rem;
      display: flex;
      align-items: center;
      .search-icon {
        margin: 0 12/100rem 0 20/100rem;
        width: 24/100rem;
        height: 27/100rem;
      }
      #search-input {
        color: #666666;
        font-size: 22/100rem;
        font-weight: bold;
        width: 75%;
        background: #fafafa;
        &::placeholder {
          color: #999999;
          font-weight: 300;
          font-size: 22/100rem;
        }
      }
      .placeholder-text {
        color: #999999;
        line-height: 18/100rem;
        font-size: 13/100rem;
      }
      .clear-icon {
        width: 80/100rem;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          opacity: 0.2;
          width: 27/100rem;
          height: 27/100rem;
        }
      }
    }
    .handle-button {
      height: 75/100rem;
      font-size: 24/100rem;
      color: #666666;
      display: flex;
      font-weight: bold;
      align-items: center;
      margin-left: 12/100rem;
    }
  }
  // 品牌列表
  .brand-list {
    display: flex;
    flex-direction: column;
    .item--hover {
      background: #f9fafb;
    }
    .item {
      display: flex;
      align-items: center;
      height: 86/100rem;
      padding: 0 19/100rem;
      flex-shrink: 0;
      img {
        width: 48/100rem;
        height: 48/100rem;
        margin-right: 17/100rem;
      }
      .brand-name {
        width: calc(100% - (48 / 100rem));
        display: flex;
        height: 86/100rem;
        align-items: center;
        color: #404040;
        line-height: 34/100rem;
        font-size: 24/100rem;
        border-bottom: 1/100rem solid #f6f6f6;
      }
    }
  }
}
</style>
